import React from 'react';

const TableauDeBordProduction = () => {

  return (

    <>
      {/* Content goes here */}
    </>

  );
};

export default TableauDeBordProduction;